export default {
  isLoggedIn: false,
  username: '',
  name: '',
  email: '',
  phone: '',
  roles: [],
  token: ''
}
